import Vue from "vue";
import EventProxy from "vue-event-proxy";
Vue.use(EventProxy);
